import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

/** Renders knowledge node bodies / descriptions as GitHub-flavored markdown. */
export function Markdown({ text }: { text: string }) {
  return (
    <div className="md">
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  )
}
